import React, { useState, useEffect, memo } from 'react';
import { Suspense, lazy } from 'react';
import ReactTooltip from 'react-tooltip';
import AnomalyList from './anomalyList';
import SearchBar from './searchBar';
// import { mobile } from './../../utils/constants';
import { feedbackAction } from '../../services/otherServices';
import { getAnomalyList } from '../../services/anomalyService';
import { filterAnomaly, uniqueList } from './../../utils/commonFunctions';
import { Row } from 'react-bootstrap';

const DetailedReport = lazy(() => import('./detailedReport'));

// Main return function
function AnomalyPage(props) {
  let alerts = sessionStorage.getItem('Status Updated')
    ? []
    : JSON.parse(sessionStorage.getItem('_chart_alerts'));
  const [anomaly, setAnomaly] = useState(alerts || []);
  const [apiFailure, setApiFailure] = useState(false);
  // const { user } = props;

  useEffect(() => {
    async function getData() {
      try {
        let { data } = await getAnomalyList();
        sessionStorage.setItem('_chart_alerts', JSON.stringify(data));
        sessionStorage.removeItem('Status Updated');
        setAnomaly(data);
      } catch (err) {
        console.log(err.response);
        setApiFailure(true);
      }
    }
    if (anomaly.length === 0) getData();
  }, [anomaly]);

  const sessionFilter = JSON.parse(sessionStorage.getItem('filter')) || {};
  const [filter, setFilter] = useState(sessionFilter);
  const anomalyFiltered =
    Object.keys(filter).length > 0 ? filterAnomaly(anomaly, filter) : anomaly;

  //getting the active ids to select card
  let session = JSON.parse(sessionStorage.getItem('selection'));
  const activeID = anomalyFiltered.length > 0 ? anomalyFiltered[0] : '';
  let id = '';
  if (session) {
    const allIDs = uniqueList(anomalyFiltered, 'anomaly_id', true);
    if (!allIDs.includes(session.anomaly_id)) {
      id = activeID.anomaly_id;
      session = activeID;
    } else {
      id = session.anomaly_id;
    }
  } else {
    id = activeID.anomaly_id;
  }
  // let id = session ? session.anomaly_id : activeID.anomaly_id;
  const [cardID, setCardID] = useState(id);
  const [selection, setSelection] = useState(session);

  //setting active id of cards
  const selectAnomaly = (aan) => {
    if (cardID !== aan.anomaly_id) {
      const pos = document.querySelector('.anomalyListCards');
      sessionStorage.setItem('scroll', pos.scrollTop);
      sessionStorage.setItem('selectedID', aan.anomaly_id);
      sessionStorage.setItem('selection', JSON.stringify(aan));
      setCardID(aan.anomaly_id);
      setSelection(aan);
    }
  };

  const selectfilter = (sel) => {
    sessionStorage.removeItem('selection');
    sessionStorage.setItem('scroll', 0);
    let length = Object.keys(sel).length > 0;
    let filteredData = length ? filterAnomaly(anomaly, sel) : anomaly;
    setCardID(filteredData[0].anomaly_id || id);
    setSelection(undefined);
    setFilter(sel);
  };

  const updateAnomaly = async (aan) => {
    let data = [...anomaly];
    let originalData = [...anomaly];
    data.forEach((s, i) => {
      if (s.anomaly_id === aan.anomaly_id) data[i] = aan;
    });
    setAnomaly(data);
    try {
      let { data: result } = await feedbackAction(aan, 'alert');
      sessionStorage.setItem('Status Updated', 'Yes');
      if (!Object.keys(aan).includes('feedbackid') || !aan.feedbackid) {
        aan.feedbackid = result.id;
        data.forEach((s, i) => {
          if (s.anomaly_id === aan.anomaly_id) data[i] = aan;
        });
        setAnomaly(data);
      }
    } catch (err) {
      setAnomaly(originalData);
    }
  };

  return (
    <div
      className='d-flex h-100'
      style={{ flexDirection: 'column', width: 'calc(100% - 60px)' }}
    >
      <Row className='m-0 flex-fill' style={{ overflow: 'auto' }}>
        <AnomalyList
          anomaly={anomaly}
          anomalyFiltered={anomalyFiltered}
          filter={sessionFilter}
          cardID={id}
          selectAnomaly={(aan) => selectAnomaly(aan)}
          selectfilter={(sel) => selectfilter(sel)}
          updateAnomaly={(aan) => updateAnomaly(aan)}
          apiFailure={apiFailure}
        />
        <Suspense fallback={<div />}>
          <DetailedReport
            selection={selection || anomalyFiltered[0]}
            anomaly={anomaly}
          />
        </Suspense>
      </Row>
      <ReactTooltip type='light' effect='solid' className='tooltiptheme' />
    </div>
  );
}

export default memo(AnomalyPage);
